import React, { Component } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

import ReceptorSelected from './ReceptorSelected';
import { FormControl } from '../../../../facturotopia';
import ReceptorSuggestions from './ReceptorSuggestions';
import ReceptorFiscalInfoForm from './receptor/ReceptorFiscalInfoForm';
import NacionalidadOptions from '../../support/catalogos/NacionalidadOptions';

class ReceptorSelection extends Component {
  state = {
    manualInfoCompletion: false,
    data: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      data: { ...props.data?.Receptor },
      isComplete: !!props.data && (!!props.data.Receptor?.Nacional || !!props.data.Receptor?.Extranjero),
    };
  }

  handleOnNacionalidadChange = (values) => {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        ...values,
      },
    });
  };

  handleOnNacionalidadReset = () => {
    this.setState({
      data: {},
      manualInfoCompletion: false,
    });
  };

  handleOnSelect = (item) => {
    const { NacionalidadR } = this.state.data;

    let value = {};

    if (NacionalidadR === 'Nacional') {
      value = {
        Email: item.email,
        RfcR: item.rfc,
        NomDenRazSocR: item.razon_social,
        CurpR: item.curp,
        DomicilioFiscalR: item.direccion?.cp,
      };
    } else {
      value = {
        Email: item.email,
        NumRegIdTribR: item.num_reg_id_trib,
        NomDenRazSocR: item.razon_social,
      };
    }

    const data = {
      NacionalidadR,
      [NacionalidadR]: value,
    };

    this.props.onChange({
      Receptor: {
        ...data,
      },
    });

    const isCompleted = !!data && (!!data.Nacional || !!data.Extranjero);

    this.setState({
      data,
      isComplete: isCompleted,
      monitorOpenForm: isCompleted,
    });
  };

  handleOnReceptorReset = (item) => {
    const { data } = this.state;

    this.props.onChange({
      Receptor: {
        data: {
          NacionalidadR: data.NacionalidadR,
        },
      },
    });

    this.setState({
      data: {
        NacionalidadR: data.NacionalidadR,
      },
      manualInfoCompletion: false,
      isComplete: false,
      monitorOpenForm: !(!!data && (!!item.Nacional || !!item.Extranjero)),
    });
  };

  handleOnReceptorManualInfoRequest = () => {
    this.setState({
      manualInfoCompletion: true,
    });
  };

  handleOnManualReceptorInfoSet = () => {
    this.handleOnSelect({
      ...this.state.data,
    });

    this.setState({
      data: {},
      manualInfoCompletion: false,
    });
  };

  handleOnReceptorChange = (values) => {
    const { data } = this.state;

    this.props.onChange({
      Receptor: {
        ...values,
        NacionalidadR: data.NacionalidadR,
      },
    });

    const isComplete = !!data && (!!values.Nacional || !!values.Extranjero);

    this.setState({
      data: {
        ...values,
        NacionalidadR: data.NacionalidadR,
      },
      manualInfoCompletion: false,
      isComplete: isComplete,
      monitorOpenForm: !isComplete,
    });
  };

  render() {
    const { data, isComplete, monitorOpenForm, manualInfoCompletion } = this.state;
    const { NacionalidadR } = data ?? {};

    return (
      <div className="z-index-top">
        {!NacionalidadR && (
          <FormControl
            type="select"
            name="NacionalidadR"
            placeholder="Nacionalidad"
            help=""
            rules={['required']}
            value={NacionalidadR}
            options={NacionalidadOptions}
            onChange={this.handleOnNacionalidadChange}
          />
        )}

        {!!NacionalidadR && (
          <>
            {!manualInfoCompletion && (
              <ReceptorSuggestions
                data={data}
                onSelect={this.handleOnSelect}
              />
            )}
            {!manualInfoCompletion && !isComplete && (
              <div className="">
                <ButtonGroup variant="">
                  <small className="help-block">
                    <Button
                      variant="link"
                      onClick={this.handleOnReceptorManualInfoRequest}
                    >
                      + Agregar manualmente
                    </Button>
                  </small>
                  <Button
                    variant="link"
                    onClick={this.handleOnNacionalidadReset}
                  >
                    + Cambiar nacionalidad
                  </Button>
                </ButtonGroup>
              </div>
            )}

            {!!manualInfoCompletion && (
              <ReceptorFiscalInfoForm
                data={data}
                autoFocus={true}
                onChange={this.handleOnReceptorChange}
              />
            )}

            {!manualInfoCompletion && isComplete && monitorOpenForm && (
              <ReceptorFiscalInfoForm
                data={data}
                autoFocus={true}
                onChange={this.handleOnReceptorChange}
              />
            )}
          </>
        )}

        {isComplete && !manualInfoCompletion && !monitorOpenForm && (
          <div className="">
            <ReceptorSelected data={data} />

            <Button
              variant="secondary"
              className="mt-3 mr-3"
              onClick={this.handleOnReceptorManualInfoRequest}
            >
              Editar
            </Button>

            <Button
              variant="secondary"
              className="mt-3"
              onClick={this.handleOnReceptorReset}
            >
              Cambiar
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default ReceptorSelection;
